<ng-container *limitUp="DEVICE_SIZE.DESKTOP">
  <my-account-floating-menu [links]="(availableLinks$ | async) ?? []" />
</ng-container>

<ng-container *smallerThan="DEVICE_SIZE.DESKTOP">
  <abstract-lines [menu]="(availableLinks$ | async) ?? []"></abstract-lines>
</ng-container>
